export default function displayName(firstName, lastName) {
  let name = "";
  if (firstName) {
    name = `${firstName} `;
  }

  if (lastName) {
    name = `${name}${lastName}`;
  }

  return name;
}
